<template>
  <el-dialog
    :title="workDia.title"
    :visible.sync="workDia.show"
    v-if="workDia.show"
    :close-on-click-modal="false"
  >
    <WorkTable :data="workData" />
    <div slot="footer" class="dialog-footer">
      <butn btntype="primary" @click.native="closeFrom()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import WorkTable from "./workTable.js";

export default {
  components: { butn, WorkTable },
  props: ["workDia", "workData"],
  methods: {
    closeFrom() {
      this.$emit("closeDia", "workDia");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
